import { FunctionalComponent, render } from 'preact';
// import { Provider } from 'react-redux';

import './styles.module.scss';
import { ThemeProvider } from '@material-ui/core';
import styles from './styles.module.scss';
import theme from '../newtab/theme';
import Counter from './Counter';
import '@fontsource/poppins';
import '@fontsource/poppins/700.css';
// import { useEffect, useRef, useState } from 'preact/hooks';
// import { lazy } from 'preact/compat';

const isExtension = () => {
  try {
    return chrome.runtime.id !== undefined;
  } catch (e) {
    return false;
  }
};

const isTabsPermissionGranted = () => {
  return new Promise((resolve) => {
    chrome.permissions.contains(
      {
        permissions: ['tabs'],
      },
      (result) => {
        resolve(result);
      }
    );
  });
};

const links = [
  {
    name: 'Bookmarks',
    url: 'chrome://bookmarks',
    icon: '/img/bookmarks.png',
  },
  {
    name: 'History',
    url: 'chrome://history',
    icon: '/img/history.png',
  },
  {
    name: 'Downloads',
    url: 'chrome://downloads',
    icon: '/img/downloads.png',
  },
  {
    name: 'Settings',
    url: 'chrome://settings',
    icon: '/img/settings.png',
  },
];

const App: FunctionalComponent = () => {
  // const trackAmplitudeEventRef = useRef(null) as any;
  // const AMPLITUDE_KEY = process.env.AMPLITUDE_KEY;
  // const [store, setStore] = useState(null);

  // useEffect(() => {
  //   const load = async () => {
  //     const { trackAmplitudeEvent, initAnalytics } = await import(
  //       '../shared/analytics'
  //     );
  //     initAnalytics(AMPLITUDE_KEY);
  //     // const store = await import('../newtab/store');

  //     // setStore(store.default);
  //     trackAmplitudeEventRef.current = trackAmplitudeEvent;
  //     trackAmplitudeEvent('popup_opened');
  //   };

  //   load();
  // }, []);

  const isExt = isExtension();

  const navigateTo = (url: string) => {
    // trackAmplitudeEventRef.current('popup_button_clicked', { url });

    if (isExt) {
      isTabsPermissionGranted().then((result) => {
        if (!result) {
          chrome.permissions.request(
            {
              permissions: ['tabs'],
            },
            (granted) => {
              if (granted) {
                chrome.tabs.create({ url });
              }
            }
          );
        } else {
          chrome.tabs.create({ url });
        }
      });
    } else {
      window.open(url);
    }
  };

  // useEffect(() => {
  //   trackAmplitudeEventRef.current('popup_opened');
  // }, []);

  return (
    <ThemeProvider theme={theme}>
      <div
        class={styles.mainContainer}
        style={{
          height: process.env.TARGET_BROWSER === 'safari' ? '11.5rem' : '20rem',
        }}
      >
        <div class={styles.header}>
          <span class={styles.headerTitle}>Contributions so far</span>
          <Counter />
        </div>

        {process.env.TARGET_BROWSER !== 'safari' && (
          <div class={styles.body}>
            {links.map((link) => (
              <button key={link.name} onClick={() => navigateTo(link.url)}>
                <img src={link.icon} alt={link.name} draggable={false} />
                <span>{link.name}</span>
              </button>
            ))}
          </div>
        )}

        <div class={styles.footer}>
          <img draggable={false} src="/img/logo-white.png" alt="OceanHero" />

          <div class={styles.footerLinks}>
            {/* <a href="https://oceanhero.today" target="_blank">
                Blog
              </a> */}

            <a
              href="https://oceanhero.today/about-us"
              target="_blank"
              rel="noreferrer"
            >
              About
            </a>
          </div>
        </div>

        <img src="/img/popup-bg.png" class={styles.bg} />
      </div>
    </ThemeProvider>
  );
};

render(<App />, document.getElementById('root'));
